import { render, staticRenderFns } from "./MensajesPantalla.vue?vue&type=template&id=088c8a1d&"
import script from "./MensajesPantalla.vue?vue&type=script&lang=ts&"
export * from "./MensajesPantalla.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports